import { getItemAnon, removeItemAnon, setItemAnon } from "utils/localstorage";
import _ from "lodash";
import { forwarderClient } from "utils/clients";
import { featureManager } from "../../src/i18n/namespace";
import { isNcl } from "utils/app/utils";

export const defaults = {};

const merge = (base, suffix) => {
    if(base.endsWith("/")) {
        return base + suffix;
    } else {
        return base + "/" + suffix;
    }
}

const externals = {
    platformBackend: process.env.REACT_APP_PLATFORM_BACKEND_URL,
    portalFrontend: process.env.REACT_APP_PORTAL_FRONTEND,
    portalBackend: process.env.REACT_APP_PORTAL_BACKEND,
    gradualDeployBackend: process.env.REACT_APP_GRADUAL_DEPLOY_API_URL,
    uiNotificationWebSocket: process.env.REACT_APP_UI_NOTIFICATION_WS,
    uiNotificationBackend: process.env.REACT_APP_UI_NOTIFICATION_URL,
    saasFrontend: process.env.REACT_APP_SAAS_FRONTEND,
    tenancyBackend: process.env.REACT_APP_TENANCY_API_URL,
    tenancyV4Backend: process.env.REACT_APP_TENANCY_V4_URL,
    stargateV4Backend: process.env.REACT_APP_BFF_V4_URL,
    stargateV4BackendGraphQlUrl: process.env.REACT_APP_BFF_V4_GRAPHQL_URL,
    saasMp: process.env.REACT_APP_SAAS_MP_API_URL,
    agentsBackend: process.env.REACT_APP_AGENTS_API_URL,
    consoleAgentsBackend: process.env.REACT_APP_CONSOLE_AGENTS_API_URL,
    ipaBackend: process.env.REACT_APP_IPA_API_URL,
    backupServiceBackend: process.env.REACT_APP_BACKUP_API_URL,
    licenseServiceBackend: process.env.REACT_APP_LICENSE_API_URL,
    subscriptionServiceBackend:process.env.REACT_APP_SUBSCRIPTION_API_URL,
    credentialServiceBackend: process.env.REACT_APP_CREDENTIAL_API_URL,
    forwarderBackend: process.env.REACT_APP_FORWARDER_BACKEND,
    auditBackend: process.env.REACT_APP_IS_DARK === "true" && !isNcl() ? merge(process.env.REACT_APP_OCCM_ENDPOINT, "occm/api/audit/local") : process.env.REACT_APP_PLATFORM_BACKEND_URL,
    spotWrapperBackend: process.env.REACT_APP_SPOT_WRAPPER_URL,
    spotIframeUrl: process.env.REACT_APP_SPOT_ENDPOINT,
    nssClientId: process.env.REACT_APP_NSS_CLIENT_ID,
    cvsServiceBackend: process.env.REACT_APP_CVS_API_URL,
    cleanIT: process.env.REACT_APP_CLEAN_IT_URL,
    cleanITAccount: process.env.REACT_APP_CLEAN_IT_ACCOUNT,
    notificationsService:process.env.REACT_APP_ALERTS_AND_NOTIFICATIONS_URL,
    supportSite:process.env.REACT_APP_SUPPORT_SITE,
    supportSiteWebsite: process.env.REACT_APP_SUPPORT_WEBSITE,
    googleAnalyticsTag: process.env.REACT_APP_GOOGLE_ANALYTICS_TAG,
    compliancereportBackend:process.env.REACT_APP_COMPLIANCE_REPORT_API_URL,
    federationBackend: process.env.REACT_APP_FEDERATION_API_URL,
    identityBackend: process.env.REACT_APP_IDENTITY_API_URL,
    identityAuthTokenUrl: `https://${process.env.REACT_APP_AUTH0_DOMAIN}`,
    rpsBackend: process.env.REACT_APP_RPS_API_URL,
    alertsBackend: process.env.REACT_APP_ALERTS_BACKEND,
    assetsBackend: process.env.REACT_APP_ASSETS_BACKEND,
    remediationBackend: process.env.REACT_APP_REMEDIATION_API_URL, //TODO: define this in SaaS when avaialble
    serviceIframes: {
        "cvo-angular": process.env.REACT_APP_ANGULAR_ENDPOINT,
        "NetApp.OntapCVO/iframe/create-cvo": process.env.REACT_APP_CVO_SERVICES_ENDPOINT,
        "NetApp.OntapONPrem/iframe/create-onprem": process.env.REACT_APP_ON_PREM_SERVICES_ENDPOINT,
        "NetApp.Replication/iframe/create": process.env.REACT_APP_REPLICATION_SERVICES_ENDPOINT,
        "NetApp.OntapCVO/iframe/create-cvo-aws": process.env.REACT_APP_CVO_AWS_ADDWE_ENDPOINT,
        "NetApp.OntapCVO/iframe/create-cvo-gcp": process.env.REACT_APP_CVO_GCP_ADDWE_ENDPOINT,
        "NetApp.OntapCVO/iframe/create-cvo-azure": process.env.REACT_APP_CVO_AZURE_ADDWE_ENDPOINT,
        "cloud-backup": process.env.REACT_APP_SFR_IFRAME_ENDPOINT,
        "cloud-insights": process.env.REACT_APP_MONITORING_IFRAME_ENDPOINT,
        "cvs": process.env.REACT_APP_CVS_IFRAME_ENDPOINT,
        "active-iq": process.env.REACT_APP_ACTIVE_IQ_IFRAME_ENDPOINT,
        "digital-advisor": process.env.REACT_APP_DIGITAL_ADVISOR_IFRAME_ENDPOINT,
        "cloud-sync": process.env.REACT_APP_CLOUD_SYNC_IFRAME_ENDPOINT,
        "cloud-tiering": process.env.REACT_APP_CLOUD_TIERING_IFRAME_ENDPOINT,
        "snapcenter": process.env.REACT_APP_SNAPCENTER_IFRAME_ENDPOINT,
        "sc_hybrid": process.env.REACT_APP_SC_HYBRID_IFRAME_ENDPOINT,
        "scv_hybrid": process.env.REACT_APP_SCV_HYBRID_IFRAME_ENDPOINT,
        "ase-fluid": process.env.REACT_APP_FLUID_IFRAME_ENDPOINT,
        "cloud-compliance": process.env.REACT_APP_COMPLIANCE_IFRAME_ENDPOINT,
        "risk-remediation": process.env.REACT_APP_RISK_REMEDIATION_IFRAME_ENDPOINT,
        "economic-efficiency": process.env.REACT_APP_ECONOMIC_EFFICIENCY_IFRAME_ENDPOINT,
        "keystone": process.env.REACT_APP_KEYSTONE_IFRAME_ENDPOINT,
        "storage-services":process.env.REACT_APP_STORAGE_IFRAME_ENDPOINT,
        "cloud-storage":process.env.REACT_APP_CLOUD_STORAGE_IFRAME_ENDPOINT,
        "eseries":process.env.REACT_APP_ESERIES_IFRAME_ENDPOINT,
        "storage-grid": process.env.REACT_APP_STORAGE_GRID_IFRAME_ENDPOINT
    },
    serviceBackends: {
        "cloud-sync": process.env.REACT_APP_CLOUD_SYNC_API_URL,
        "tiering": process.env.REACT_APP_TIERING_API_URL,
        "fsx": process.env.REACT_APP_FSX_API_URL,
        "storage-services":process.env.REACT_APP_STORAGE_API_URL,
        "cloud-storage":process.env.REACT_APP_CLOUD_STORAGE_API_URL,
        "eseries":process.env.REACT_APP_ESERIES_API_URL,
        "ontap-service": process.env.REACT_APP_ONTAP_API_URL,
        "database-services":process.env.REACT_APP_DATABASE_API_URL,
        "fsx-storage":process.env.REACT_APP_FSX_STORAGE_API_URL,
        "gcnv-service":process.env.REACT_APP_GCNV_SERVICE_API_URL,
    },
    serviceMfes: {},
    serviceShadowDoms: {
        "NetApp.AIDataCurator/mfe/datacurator": process.env.REACT_APP_AIDE_CURATOR_MFE_ENDPOINT,
        "NetApp.DataMap/mfe/datamap": process.env.REACT_APP_AIDE_DATAMAP_MFE_ENDPOINT,
        "NetApp.AIDataExplorer/mfe/dataexplorer": process.env.REACT_APP_AIDE_EXPLORER_MFE_ENDPOINT,
        "NetApp.AISettings/mfe/datasettings": process.env.REACT_APP_AIDE_SETTINGS_MFE_ENDPOINT,
    },
    supportServiceUrl: "https://mysupport.netapp.com/site/help"
};

const endpointRegex = /^(?<service>[^/]+)\/(?<purpose>[^/]+)\/(?<key>[^/]+$)/;

function interceptSaaSFrontend() {
    //we've 2 old domains: cloudmanager & bluexp
    const isOldDomain = window.location.origin !== process.env.REACT_APP_SAAS_FRONTEND;
    if (isOldDomain) {
        //we only had 1 saas frontend variable before, so setting saasFrontend to the old one
        //this is to ensure that the old domain is used for the saas frontend when origin is 
        // not pointing to the new domain
        externals.saasFrontend = process.env.REACT_APP_SAAS_OLD_FRONTEND;
    }
}

export const setExternals = ({supportServices, isDemo, servicesList, environment}) => {

    if (process.env.REACT_APP_IS_SAAS === "true"){
        interceptSaaSFrontend();
    }

    if(isNcl()) {
        externals.alertsBackend = `${process.env.REACT_APP_OCCM_ENDPOINT}v1/alert`
        externals.assetsBackend = `${process.env.REACT_APP_OCCM_ENDPOINT}v1/services/assets`
        externals.federationBackend = `${process.env.REACT_APP_OCCM_ENDPOINT}v1/services/federation`
        externals.remediationBackend = `${process.env.REACT_APP_OCCM_ENDPOINT}v1/services/remediation`;
        externals.identityBackend = `${process.env.REACT_APP_OCCM_ENDPOINT}v1/Netapp.Identity`;
        externals.identityAuthTokenUrl = `${process.env.REACT_APP_OCCM_ENDPOINT}`;
    }

    if(supportServices) {
        externals.platformBackend = supportServices.platformServiceInformation?.url;
        externals.portalFrontend = supportServices.portalService?.portalInformation?.portalFrontEnd;
        externals.portalBackend = supportServices.portalService?.portalInformation?.portalBackEnd;
        externals.saasFrontend = supportServices.portalService?.saasFrontEnd;
        externals.tenancyBackend = supportServices.tenancyServiceInformation?.url;
        /**
         * This change is added to set the api url for tenancy incase of connector local and restricted side.
         * TODO this varaibles to be removed when the support-service api will support the new endpoint.
         */
        if (process.env.REACT_APP_IS_DARK === "true") {
            externals.tenancyV4Backend = `${process.env.REACT_APP_OCCM_ENDPOINT}v1/management`;
            externals.stargateV4Backend = `${process.env.REACT_APP_OCCM_ENDPOINT}v1/services/ui-controller`
            externals.stargateV4BackendGraphQlUrl = `${process.env.REACT_APP_OCCM_ENDPOINT}v1/services/ui-controller/graphql`
        } else if (environment) {
            const stageEnv = environment === "production" ? "" : `${environment}.`;
            externals.tenancyV4Backend = `https://${stageEnv}api.bluexp.netapp.com/v1/management`;
            externals.stargateV4Backend = `https://${stageEnv}api.bluexp.netapp.com/v1/services/ui-controller`
            externals.stargateV4BackendGraphQlUrl = `https://${stageEnv}api.bluexp.netapp.com/v1/services/ui-controller/graphql`
            externals.assetsBackend = `https://${stageEnv}api.bluexp.netapp.com/v1/services/assets`
            externals.federationBackend = `https://${stageEnv}api.bluexp.netapp.com/v1/services/federation`
        }
        externals.ipaBackend = supportServices.ipaServiceInformation?.url;
        externals.backupServiceBackend = supportServices.servicesInformation?.cbs?.apiUrl;
        externals.licenseServiceBackend = supportServices.licenseServiceInformation?.url;
        externals.credentialServiceBackend = supportServices.credentialsServiceInformation?.url;
        externals.saasMp = supportServices.saasMpServiceInformation?.url;
        externals.auditBackend = process.env.REACT_APP_IS_DARK === "true" && !isNcl() ? merge(process.env.REACT_APP_OCCM_ENDPOINT, "occm/api/audit/local") : supportServices.platformServiceInformation?.url;
        externals.agentsBackend = supportServices.tenancyServiceInformation?.agentsMgmtUrl;
        externals.forwarderBackend = supportServices.tenancyServiceInformation?.forwarderUrlOverride;
        externals.uiNotificationWebSocket =  supportServices.notificationServiceInformation?.wsUrl;
        externals.uiNotificationBackend = supportServices.notificationServiceInformation?.url;
        externals.notificationsService = supportServices.alertsAndNotificationServiceInformation?.url;
        externals.serviceBackends["ontap-service"] = supportServices.platformServiceInformation?.url + "/ontap-service"
        externals.cvsServiceBackend = supportServices.cvsServiceInformation?.url;
        externals.storageManagementBackend = _.get(supportServices, "servicesInformation.storagemanagement.apiUrl");

        externals.serviceIframes["cloud-backup"] = _.get(supportServices, "servicesInformation.cbs.iframeUrl");
        externals.serviceIframes["cloud-insights"] = _.get(supportServices, "servicesInformation.monitoring.iframeUrl");
        externals.serviceIframes["cvs"] = _.get(supportServices, "cvsInformation");
        externals.serviceBackends["cloud-sync"] = _.get(supportServices, "servicesInformation.cloudSync.apiUrl");
        externals.serviceBackends["tiering"] = _.get(supportServices, "servicesInformation.cloudTiering.apiUrl");
        externals.serviceIframes["active-iq"] = _.get(supportServices, "servicesInformation.activeIq.iframeUrl");
        externals.serviceIframes["digital-advisor"]=_.get(supportServices, "servicesInformation.digitalAdvisor.iframeUrl");
        externals.serviceIframes["cloud-sync"] = _.get(supportServices, "servicesInformation.cloudSync.iframeUrl");
        externals.serviceIframes["cloud-tiering"] = _.get(supportServices, "servicesInformation.cloudTiering.iframeUrl");
        externals.serviceBackends["snapcenter"] = _.get(supportServices, "servicesInformation.snapCenter.apiUrl");
        externals.serviceIframes["snapcenter"] = _.get(supportServices, "servicesInformation.snapCenter.iframeUrl");
        externals.serviceIframes["ase-fluid"] = _.get(supportServices, "servicesInformation.fluid.iframeUrl");
        externals.serviceIframes["cloud-compliance"] = _.get(supportServices, "servicesInformation.compliance.iframeUrl");
        externals.serviceBackends["fsx"] = _.get(supportServices, "servicesInformation.fsx.apiUrl");
        externals.serviceBackends["keystone"] = _.get(supportServices, "servicesInformation.keystone.iframeUrl");
        externals.serviceIframes["ransomware-protection"] = _.get(supportServices, "servicesInformation.ransomwareprotection.iframeUrl");
        externals.serviceIframes["NetApp.SystemManager/iframe/systemmanager"] = _.get(supportServices, "servicesInformation.systemmanager.iframeUrl");
        externals.serviceIframes["NetApp.OntapCVO/iframe/create-cvo"] = _.get(supportServices, "servicesInformation.cvo.iframeUrl");
        externals.serviceIframes["NetApp.OntapONPrem/iframe/create-onprem"] = _.get(supportServices, "servicesInformation.cvo.iframeUrl");
        externals.serviceIframes["NetApp.Replication/iframe/create"] = _.get(supportServices, "servicesInformation.cvo.iframeUrl");
        externals.serviceIframes["NetApp.BackupUbr/iframe/unified_br"] = _.get(supportServices, "servicesInformation.unified_br.iframeUrl");
        externals.serviceIframes["NetApp.Backup/iframe/disaster-recovery"] = _.get(supportServices, "servicesInformation.cloudmanager_dr.iframeUrl");
        
        forwarderClient.defaults.baseURL = externals.forwarderBackend;
    }

    if(isDemo) {
        externals.serviceBackends["cloud-sync"] = process.env.REACT_APP_CLOUD_SYNC_DEMO_API_URL;
        externals.serviceBackends["tiering"] = process.env.REACT_APP_TIERING_DEMO_API_URL;
        externals.serviceIframes["cloud-sync"] = process.env.REACT_APP_CLOUD_SYNC_DEMO_IFRAME_ENDPOINT;
        externals.serviceIframes["cloud-tiering"] = process.env.REACT_APP_CLOUD_TIERING_DEMO_IFRAME_ENDPOINT;
        externals.serviceBackends["storage-services"] = process.env.REACT_APP_STORAGE_DEMO_API_URL;
        externals.serviceBackends["cloud-storage"] = process.env.REACT_APP_CLOUD_STORAGE_DEMO_API_URL;
        externals.serviceBackends["eseries"] = process.env.REACT_APP_ESERIES_DEMO_API_URL;
        externals.serviceIframes["storage-services"] = process.env.REACT_APP_STORAGE_DEMO_IFRAME_ENDPOINT;
        externals.serviceIframes["cloud-storage"] = process.env.REACT_APP_CLOUD_STORAGE_DEMO_IFRAME_ENDPOINT;
        externals.serviceIframes["eseries"] = process.env.REACT_APP_ESERIES_DEMO_IFRAME_ENDPOINT;
    }

    if(servicesList) {
        const servicesWithEndpoints = servicesList.filter(service => service.uiIntegration?.endpoints);
        servicesWithEndpoints.forEach(service => {
            for(const endpointKey in service.uiIntegration.endpoints) {
                const endpointValue = service.uiIntegration.endpoints[endpointKey];
                const matchedStageIntegration = service.uiIntegration.stageIntegrations?.find(stageIntegration => stageIntegration.endpointId === endpointKey);
                if(matchedStageIntegration) {
                    const { renderType } = matchedStageIntegration;
                    if (renderType === "mfe/v1") {
                        externals.serviceMfes[endpointKey] = endpointValue;
                    } else if (renderType === "mfe/v2") {
                        externals.serviceShadowDoms[endpointKey] = endpointValue;
                    } else {
                        externals.serviceIframes[endpointKey] = endpointValue;
                    }
                }
            }
        })
        const servicesWithAPIEndpoints = servicesList.filter(service => service.uiIntegration?.apiEndpoints);
    }

    Object.assign(defaults, _.cloneDeep(externals));

    const externalOverrides = getItemAnon({itemKey: "externals"});

    if(externalOverrides) {
        _.map(externalOverrides, (val, key) => {
            _.set(externals, getNewKeyNameForOverriding(key), val);
        })
    }
};

export const restoreDefaults = () => {
    Object.assign(externals, _.cloneDeep(defaults));
    removeItemAnon({itemKey: "externals"});
}

export const overrideExternal = (key, value) => {
    
    _.set(externals, getNewKeyNameForOverriding(key), value);
    const externalOverrides = getItemAnon({itemKey: "externals"}) || {};
    externalOverrides[key] = value;
    setItemAnon({itemKey: "externals"}, externalOverrides);

    // Check if the key is for an MFE and reload the page
    const match = endpointRegex.exec(key);    
    if (match) {
        const { purpose } = match.groups;
        if (purpose === "mfe") {
            window.location.reload();
        }
    }
};

const getNewKeyNameForOverriding = (key) => key.replace(/NetApp\.+/, "NetApp:")
    .replace(/Test\.+/, "Test:")
    .split(".")
    .map(a => a.replace("NetApp:", "NetApp.")
    .replace("Test:", "Test."))
;

export default externals;
